import { render } from "./Portfolio.vue?vue&type=template&id=d503691a&scoped=true"
const script = {}

import "./Portfolio.vue?vue&type=style&index=0&id=d503691a&lang=scss&scoped=true"

import exportComponent from "C:\\Users\\Fabiano\\OneDrive\\Área de Trabalho\\Project\\campinasredesdeprotecao\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d503691a"]])

export default __exports__